module.exports = __webpack_public_path__ + "img/SignIn_icon_01.21efb111.png";